module.exports = __webpack_public_path__ + "img/graph_DE.27977626.jpg";